import { Tooltip } from 'antd';
import React from 'react';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import ConversationDrawer from '../Conversations/ConversationDrawer';
import ConversationType from '../Conversations/ConversationType';
import TitleActionsScroller from '../Title/TitleActionsScroller';
import TitleDetailDrawer from '../Title/TitleDetailDrawer';
import TitleImage from '../Title/TitleImage';
import TitleReviewBursts from '../Title/TitleReviewBursts';
import Scroller from '../UI/Scroller/Scroller';
import './titleScroller.css';

export class TitleScroller extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			maxTitles: 40,
		};
	}

	renderTitles() {
		const { titles } = this.props;

		return (
			<React.Fragment>
				{titles && titles.length > 0 && titles.map(this.renderOneTitle)}
			</React.Fragment>
		);
	}

	showMore = () => {
		const { maxTitles } = this.state;
		this.setState({
			maxTitles: maxTitles * 1 + 20,
		});
	};

	renderTitleWithDrawer = (communityId, title) => {
		return (
			<TitleDetailDrawer sku={title.sku} communityId={communityId}>
				<div>
					<div className="relative">
						<TitleImage title={title} />
					</div>
					<TitleReviewBursts
						reviews={title.reviews}
						rating={title.average}
					/>
				</div>
			</TitleDetailDrawer>
		);
	};

	renderOneTitle = (title, idx) => {
		const { titles, communityId, conversations } = this.props;
		const conversation =
			conversations &&
			conversations.length > 0 &&
			conversations.filter(con => con.conversationId === title.sku);
		const unread =
			conversation && conversation.filter(con => !con.status).length > 0;
		const totalTitles = titles.length;
		const { maxTitles } = this.state;

		if (idx >= maxTitles) {
			return (
				idx === maxTitles &&
				totalTitles > idx && (
					<Tooltip title="See more" key={idx}>
						<div
							className="icon-arrow-right-alt1 scroller-more"
							onClick={this.showMore}
						/>
					</Tooltip>
				)
			);
		}

		return (
			<div
				key={title.sku}
				className="relative"
				style={{ marginLeft: '5px' }}>
				<div
					style={{
						marginRight: '10px',
						marginBottom: '10px',
						marginTop: '5px',
						boxShadow: '4px 4px 5px 0 rgba(0,0,0,.6)',
						minWidth: '75px',
					}}>
					{this.renderTitleWithDrawer(communityId, title)}
					{conversation && conversation.length > 0 && (
						<ConversationDrawer
							type={ConversationType.Title}
							id={title.sku}
							communityId={communityId}
							text={this.getConversationName(title)}>
							<Tooltip
								title={
									<span style={{ fontSize: '11px' }}>
										{unread
											? 'Unread Community Conversation'
											: 'Read Community Conversation'}
									</span>
								}
								placement="top">
								<div
									className={`icon-chat scroller-conversation-icon-${
										unread ? 'unread' : 'read'
									}`}></div>
							</Tooltip>
						</ConversationDrawer>
					)}
				</div>
				<TitleActionsScroller title={title} />
			</div>
		);
	};

	getConversationName = title => {
		return (
			<span>
				<span className="bold">{title.name}</span> by {title.author}
			</span>
		);
	};

	renderLaneHeader = () => {
		const { majorHeader, subHeader, icon } = this.props;
		const isMobile = this.props.isMobile();

		if (majorHeader || subHeader) {
			return (
				<div className="lane-headers">
					<div>
						{majorHeader && (
							<div
								className={`${
									!isMobile
										? 'lane-primary-header'
										: 'lane-primary-header-mobile'
								}`}>
								{this.getLanePrimaryHeader(majorHeader, icon)}
							</div>
						)}
						{subHeader && (
							<div
								className={`${
									!isMobile
										? 'lane-subheader'
										: 'lane-subheader-mobile'
								}`}>
								<span>{subHeader}</span>
							</div>
						)}
					</div>
					{this.props.extra && (
						<div style={{ paddingRight: 20 }}>
							{this.props.extra}
						</div>
					)}
				</div>
			);
		}

		return <React.Fragment />;
	};

	getLanePrimaryHeader(headerValue, icon) {
		return (
			<div>
				<div className={`icon-${icon} major-header-icon-large`} />
				<div className="column-spaced">
					<span className="major-header">{headerValue}</span>
				</div>
				<div className="clear" />
			</div>
		);
	}

	render() {
		return (
			<div>
				<div style={{ paddingBottom: '10px' }}>
					{this.renderLaneHeader()}
					<div style={{ marginTop: '5px' }}>
						<Scroller>{this.renderTitles()}</Scroller>
					</div>
				</div>
			</div>
		);
	}
}

export default withIsMobile(TitleScroller);
